export type CanLoadMoreArgs = {
  /** A `loadMore` page request is already in flight. */
  loadingMore: boolean;
  /** The current `useQuery` request (first page or a later one) is still loading. */
  loading: boolean;
  /** Weeks committed to the list so far. */
  groupsCount: number;
};

/**
 * Whether the infinite-scroll handler may advance the offset.
 *
 * The scroll handler fires on the short <Loading /> page as well, and paging before the first
 * batch has landed swaps the query variables; with fetchPolicy `no-cache` Apollo then drops the
 * in-flight first page, so the list would start at week N-3 instead of the newest week. Paging is
 * therefore allowed only once a page is in and nothing is loading.
 */
export const canLoadMore = ({ loadingMore, loading, groupsCount }: CanLoadMoreArgs): boolean =>
  !loadingMore && !loading && groupsCount > 0;
